// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__pJLXF","inline":"Checkbox_inline__3ReFW"};